<!--
 * @Author: cgh
 * @Date: 2022-07-21
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:03:44
 * @Description: 问题列表
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50 o-dialog-h--85 o-resize-hieght"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmId"
            >
              <el-select
                v-if="dlType==='add'"
                v-model="fd.xmId"
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in xmList"
                  :key="index"
                  :label="item.xmmc"
                  :value="item.id"
                />
              </el-select>
              <span
                v-else
                class="c-form__read"
              >{{ fd.xmMc }}</span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="安全类别"
              prop="aqlbDm"
            >
              <select-sb
                v-model="fd.aqlbDm"
                required
                type="pg"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="具体位置"
              prop="szwz"
            >
              <el-input
                v-model="fd.szwz"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入具体位置！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="不符合检查项个数"
              prop="bfhgs"
            >
              <el-input
                v-model="fd.bfhgs"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入不符合检查项个数"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="风险类别"
              prop="fxcd"
            >
              <el-select
                v-model="fd.fxcd"
                class="c-form__select"
                style="width: 100%;"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in fxlbType"
                  :key="item.id"
                  :value="item.id"
                  :label="item.text"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="重大火灾隐患"
              prop="zdhzyh"
            >
              <el-radio-group v-model="fd.zdhzyh">
                <el-radio label="Y">
                  是
                </el-radio>
                <el-radio label="N">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="问题描述"
              prop="wtxq"
            >
              <el-input
                v-model="fd.wtxq"
                type="textarea"
                :rows="3"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入问题描述！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="对策和措施"
              prop="dccs"
            >
              <el-input
                v-model="fd.dccs"
                type="textarea"
                :rows="3"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入对策和措施！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="检验依据"
              prop="jcyj"
            >
              <el-input
                v-model="fd.jcyj"
                type="textarea"
                :rows="3"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入检验依据！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="可能产生的后果"
              prop="fxms"
            >
              <el-input
                v-model="fd.fxms"
                type="textarea"
                :rows="3"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入可能产生的后果！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="具体图片"
              prop="fjIdList"
            >
              <image-upload
                ref="files"
                v-model="fd.fjIdList"
                multiple-file
                :file-api="$config.ctx.hmfileApi"
                show-file-list
                accept="image/*"
                :data="uploadFd"
                list-type="picture-card"
              >
                <i
                  slot="default"
                  class="el-icon-plus"
                />
              </image-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wtlbManageService } from './wtlb.service.js';
import { pgxmManageService } from '../pgxm/pgxm.service.js';
export default {
  name: 'AddDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      /* 表单参数 Start */
      fd: {
        id: null,
        dxzbId: null,
        fxzbId: null,
        aqlbDm: null, // 安全类别
        xmId: null,
        xmMc: null, // 客户名称
        szwz: null, // 具体位置
        bfhgs: null, // 数量
        fxcd: null, // 风险类别代码
        fxcdMc: null, // 风险类别名称
        zdhzyh: null, // 重大火灾隐患代码
        wtxq: null, // 问题描述
        dccs: null, // 对策和措施
        jcyj: null, // 检验依据
        fxms: null, // 可能产生的后果
        fjIdList: [] // 相关附件
      },
      xmList: [],
      // dialogImageUrl: '', // 图片路径
      // dialogVisible: false,
      disabled: false,
      showDialogName: null,
      fileList: [],
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        xmId: [this.$validUtils.required('项目名称')],
        bfhgs: [this.$validUtils.required('数量'), this.$HMValidator.number('数量'), this.$validUtils.maxLengthValid('数量', 8)],
        fxcd: [this.$validUtils.required('风险类别')],
        zdhzyh: [this.$validUtils.required('重大火灾隐患'), this.$HMValidator.maxLength('重大火灾隐患', 300)],
        aqlbDm: [this.$validUtils.required('安全类别')],
        wtxq: [this.$validUtils.required('问题描述'), this.$HMValidator.maxLength('问题描述', 300)],
        dccs: [this.$validUtils.required('对策和措施'), this.$HMValidator.maxLength('对策和措施', 300)],
        szwz: [this.$validUtils.required('具体位置'), this.$HMValidator.maxLength('具体位置', 300)],
        jcyj: [this.$HMValidator.maxLength('检测依据', 300)],
        fxms: [this.$HMValidator.maxLength('可能产生的后果', 300)]
      },
      /* 表单校验规则 End */
      // aqlbType: '',
      // fxlbType: '',
      dlType: 'add', // 模态框类型，'add': 新增，'edit': 修改
      uploadFd: { // 上传服务入参
        meta: [
          {
            key: 'pgwt',
            value: null
          }
        ]
      }
      /* 文件服务器对接参数 END */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改信息' : '添加信息'}`;
    },
    aqlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_AQLB) {
        return enums.IFF_AQLB;
      }
      return {};
    },
    fxlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_FXLB) {
        return enums.IFF_FXLB;
      }
      return {};
    }

  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init (_id) {
      this.loading = true;
      wtlbManageService.getDetail(_id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
          this.fd.aqlbDm = `${rsp.data.fxzbId}/${rsp.data.dxzbId}`;
        })
        .catch(err => {
          console.error('获取评估仪器信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * 获取项目名称列表
     */
    getXmList () {
      pgxmManageService.query()
        .then(rsp => {
          this.xmList = rsp.data.rows;
        })
        .catch(err => {
          console.error('查询错误！', err);
        });
    },
    // 删除图片
    handleRemove (file) {
      this.$refs.files.handleRemove(file);
      // 删除数据xgfj中的图片
      this.fd.xgfj.some((item, i) => {
        if (item === file.url) {
          this.fd.xgfj.splice(i, 1);
          // 在数组的some方法中，如果return true，就会立即终止这个数组的后续循环
          return true;
        }
      });
    },
    // 放大图片
    handlePictureCardPreview (file) {
      this.showDialogName = 'img';
      this.dialogParams = file;
    },
    // 下载图片
    handleDownload (file) {
      this.downloadIamge(file.url, file.name);
    },
    /**
     * 下载文件
     */
    downloadIamge (imgsrc, name) {
      // 下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function () {
        var canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL('image/png'); // 得到图片的base64编码数据

        var a = document.createElement('a'); // 生成一个a元素
        var event = new MouseEvent('click'); // 创建一个单击事件
        a.download = name || 'photo'; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    /**
     * 文件上传
     */
    handleChange (file) {
      console.log(file);
      // this.fd.fileList.push(file.url);
      console.log(this.fd.fileList);
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          [this.fd.fxzbId, this.fd.dxzbId] = this.fd.aqlbDm.split('/');
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      wtlbManageService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      wtlbManageService.update(this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改问题列表错误！', err);
          this.loading = false;
        });
    }

  },
  created () {
    // 判断是否是修改
    if (this.dlParams.id) {
      this.dlType = this.dlParams.type;
      this.init(this.dlParams.id);
    } else {
      this.getXmList();
    }
  }
};

</script>
<style lang="scss">
.o-dialog-h--85.o-resize-hieght>.el-dialog {
  height: 89%;
}
</style>
